/* Les chiffres du rail : ce qui attend quelque chose, et rien d'autre.
 *
 * Un seul comptage depuis le resserrage sur le périmètre V1 : les cinq autres
 * portaient des entrées de menu qui ont quitté le menu — les compter aurait
 * coûté cinq requêtes par changement d'écran pour un chiffre que personne ne
 * voit. Elles reviendront avec leur écran, le jour où il revient.
 *
 * Sans ramener une seule ligne : `head` suffit. Les politiques de la base
 * filtrent déjà selon le niveau — un agent compte ses commissions, pas celles
 * des autres. */

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export interface Compteurs {
  commissions: number;
}

const VIDE: Compteurs = { commissions: 0 };

async function compter(
  table: string,
  filtre: (q: ReturnType<typeof requete>) => ReturnType<typeof requete>,
): Promise<number> {
  const { count, error } = await filtre(requete(table));
  return error ? 0 : (count ?? 0);
}

function requete(table: string) {
  return supabase.from(table).select("*", { count: "exact", head: true });
}

export function useCompteurs(): Compteurs {
  const [c, setC] = useState<Compteurs>(VIDE);
  const lieu = useLocation();
  /* On recompte en changeant d'écran : c'est le moment où un chiffre a pu
     bouger, et c'est une requête sans données. */
  const racine = `/${lieu.pathname.split("/")[1] ?? ""}`;

  useEffect(() => {
    let vivant = true;
    void compter("commissions", (q) => q.eq("etat", "a_facturer")).then((commissions) => {
      if (vivant) setC({ commissions });
    });
    return () => {
      vivant = false;
    };
  }, [racine]);

  return c;
}
